import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import ModernPortfolio from './ModernPortfolio';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ModernPortfolio />
  </React.StrictMode>
);